import PageContainerStyle from "./PageContainer.styles";

const PageContainer = ({ children }) => {
  const classes = PageContainerStyle();
  return <div className={classes.PageContainer}>{children}</div>;
};
export default PageContainer;
